<template>
  <div id="profileTab">
    <b-card-group columns>
      <b-card no-body>
        <b-card-header>
          Image
        </b-card-header>
        <b-table-simple>
          <b-tr>
            <b-td class="text-center">
              <img style="max-width:100%;" :src="'https://cdn.gokaizen.com/' + $store.state.global.category.thumbnail" alt="">
            </b-td>
          </b-tr>
        </b-table-simple>
      </b-card>

      <b-card no-body>
        <b-card-header>
          Description
        </b-card-header>
        <b-table-simple>
          <b-tr>
            <b-td>Created</b-td>
            <b-td class="text-right">
              {{ $store.state.global.category.created | moment("YYYY-MM-DD") }}
            </b-td>
          </b-tr>
          <b-tr>
            <b-td>Updated</b-td>
            <b-td class="text-right">
              {{ $store.state.global.category.updated | moment("YYYY-MM-DD") }}
            </b-td>
          </b-tr>
        </b-table-simple>
      </b-card>
    </b-card-group>
  </div>
</template>

<script>
export default {
  name: 'MediacategoryProfileTab',
};
</script>
